import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from '../../../../components/Button'
import MultipleOptionsField from '../../../ReusableFormFields/MultipleOptionsField'
import GoogleAdPreviewSearch1 from '../GoogleAssetsSliderPreview/Previews/GoogleAdPreviewSearch1'

import { CLICK_THROUGH_LINK, DESCRIPTIONS_LIST, descriptionsMaxLengthSchema, HEADLINES_LIST } from '../fields'

import useStepFormStyles from '../../../../styles/common/stepForms'
import useStyles from '../styles'

const stepFields = [DESCRIPTIONS_LIST]

function DescriptionsStep({ formik, handleStepChange, showPreview = true }) {
  const { t } = useTranslation()
  const commonClasses = useStepFormStyles()
  const classes = useStyles()

  const { values } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields, values)
  }, [handleStepChange, values])

  const clickThroughLink = values[CLICK_THROUGH_LINK]
  const headlinesList = values[HEADLINES_LIST]
  const descriptionList = values[DESCRIPTIONS_LIST]

  const adPreviewValues = useMemo(
    () => ({
      [CLICK_THROUGH_LINK]: clickThroughLink,
      [HEADLINES_LIST]: headlinesList,
      [DESCRIPTIONS_LIST]: descriptionList
    }),
    [clickThroughLink, headlinesList, descriptionList]
  )

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Add up to 5 descriptions (at least 2)')}</div>
      <div className={commonClasses.stepBody}>
        <p>{t('The description provides additional context or details and may appear after the headline.')}</p>
        <p>
          Consider explaining your headlines in more detail (e.g. <i>“We service all makes and models”</i>,
          <i> “Over 10 Years’ Experience”</i> etc.)
        </p>
        {showPreview && (
          <div className={classes.previewWrapper}>
            <GoogleAdPreviewSearch1 values={adPreviewValues} />
          </div>
        )}
        <MultipleOptionsField
          fieldLabel="Description"
          maxLengthSchema={descriptionsMaxLengthSchema}
          listFieldName={DESCRIPTIONS_LIST}
          formik={formik}
          minListQuantity={2}
        />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

DescriptionsStep.propTypes = {
  handleStepChange: PropTypes.func,
  formik: PropTypes.object
}

export default DescriptionsStep
